import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      image: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20movie%20collage%20with%20dramatic%20film%20scenes%2C%20dark%20atmosphere%2C%20golden%20and%20red%20accent%20lighting%2C%20movie%20poster%20aesthetic%2C%20professional%20film%20photography%20style%2C%20rich%20contrast&width=1920&height=900&seq=hero-slide-1&orientation=landscape",
      title: "聚合全网优质视频",
      subtitle: "香蕉视频 · 红桃视频 · 91视频 · 蜜桃视频",
      desc: "一站式高清在线观看，不缓冲流畅播放",
    },
    {
      image: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20atmosphere%20with%20warm%20red%20velvet%20curtains%20and%20dramatic%20spotlight%2C%20film%20premiere%20aesthetic%2C%20luxurious%20dark%20tones%2C%20professional%20photography&width=1920&height=900&seq=hero-slide-2&orientation=landscape",
      title: "最新大片抢先看",
      subtitle: "流浪地球3 · 封神第二部 · 哪吒2",
      desc: "4K超高清画质，杜比全景声体验",
    },
    {
      image: "https://readdy.ai/api/search-image?query=Modern%20streaming%20entertainment%20concept%20with%20abstract%20geometric%20shapes%2C%20vibrant%20orange%20and%20warm%20tones%2C%20digital%20media%20aesthetic%2C%20clean%20minimal%20composition%2C%20cinematic%20lighting&width=1920&height=900&seq=hero-slide-3&orientation=landscape",
      title: "海量内容每日更新",
      subtitle: "电影 · 电视剧 · 综艺 · 动漫 · 短视频",
      desc: "覆盖八大分类，满足你的所有观看需求",
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="首页横幅">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/60"></div>
        </div>
      ))}

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full px-4 md:px-6 text-center">
          <div
            key={currentSlide}
            className="animate-[slideUp_0.6s_ease]"
          >
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-3" style={{ fontFamily: "var(--font-heading)" }}>
              <strong>{slides[currentSlide].title}</strong>
            </h1>
            <p className="text-sm md:text-lg text-white/80 mb-2 max-w-2xl mx-auto">
              {slides[currentSlide].subtitle}
            </p>
            <p className="text-xs md:text-base text-white/60 mb-6 md:mb-8">
              {slides[currentSlide].desc}
            </p>
            <div className="flex items-center justify-center gap-3 flex-wrap">
              <Link
                to="/category/dianying"
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full text-sm font-medium bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line"></i>
                立即观看
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full text-sm font-medium border border-white/30 text-white hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={prevSlide}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/20 hover:bg-white/40 flex items-center justify-center transition-colors cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-white text-lg"></i>
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/20 hover:bg-white/40 flex items-center justify-center transition-colors cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-white text-lg"></i>
      </button>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === currentSlide ? "bg-primary-500 w-6" : "bg-white/50 hover:bg-white/80"
            }`}
            aria-label={`第${index + 1}张`}
          ></button>
        ))}
      </div>

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}